import addCalendarEventsAndNotify from './addCalendarEventsAndNotify';
import deleteCalendarEventsAndNotify from './deleteCalendarEventsAndNotify';
import getCalendarEventByItemIdFromCache from './getCalendarEventByItemIdFromCache';
import { CalendarEvent } from 'mini-calendar-event-types';
import { getGuid } from 'owa-guid';
import {
    addMinutes,
    differenceInMinutes,
    getDisplayDateFromEwsDate,
    getTimestamp,
    startOfDay,
} from 'owa-datetime';
const assign = require('object-assign');

/**
 * Updates the events in events store for the given itemIds and notify consumers using event emitter
 * @param itemIds The ids of the items to be updated
 * @param calendarEventUpdates The calendar event updates
 */
export default function updateCalendarEventsByItemIdsAndNotify(
    itemIds: string[],
    calendarEventUpdates: Partial<CalendarEvent>,
    shouldUpdateItem: (item: CalendarEvent) => boolean
) {
    const existingCalendarEvents = itemIds.map(getCalendarEventByItemIdFromCache);
    const calendarEventsToBeUpdated = existingCalendarEvents.filter(shouldUpdateItem);
    deleteCalendarEventsAndNotify(calendarEventsToBeUpdated);

    /**
     * Now, we have deleted instances of recurrence with old data and time to add new instances with new details.
     * Here when the updates are of time, we need to ensure that we update the key as well as start/end time in relation to
     * correct date of the instance.
     * If key is not updated, the insertion of the event will not happen at the right index
     */

    let startMinutesFromStartOfDay = null;
    let endMinutesFromStartOfDay = null;
    // Only calculate start and end offsets if the updates are about them
    if (calendarEventUpdates?.Start || calendarEventUpdates?.End) {
        startMinutesFromStartOfDay = differenceInMinutes(
            calendarEventUpdates.Start,
            startOfDay(calendarEventUpdates.Start)
        );
        endMinutesFromStartOfDay = differenceInMinutes(
            calendarEventUpdates.End,
            startOfDay(calendarEventUpdates.End)
        );
    }
    const updatedCalendarEvents = calendarEventsToBeUpdated.map(item => {
        /**
         * Temporarily changing the ChangeKey for local update so that no duplicate instances
         * for multi-day events are displayed.
         * https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/62901
         */

        let calendarEventTimeUpdates = {};

        // Only update Start And End if required
        if (startMinutesFromStartOfDay || endMinutesFromStartOfDay) {
            const startValue = addMinutes(startOfDay(item.Start), startMinutesFromStartOfDay);
            calendarEventTimeUpdates = {
                Start: startValue,
                End: addMinutes(startOfDay(item.End), endMinutesFromStartOfDay),
                Key: {
                    timestamp: getTimestamp(getDisplayDateFromEwsDate(startValue)),
                    itemId: item.ItemId?.Id,
                },
            };
        }
        return assign(new CalendarEvent(), item, calendarEventUpdates, calendarEventTimeUpdates, {
            ItemId: { ...item.ItemId, ChangeKey: getGuid() },
        });
    });
    addCalendarEventsAndNotify(updatedCalendarEvents);
}
